import { elevarTrackedRoutes } from '../data/elevarRoutes';
import { useElevar } from '../hooks/useElevar';
import { useLocation } from 'react-router-dom';
/**
 * Renders nothing. Loads Elevar tracking on the Zafira advertorial routes
 * listed in data/elevarRoutes.ts, and stays inert everywhere else.
 */
export function ElevarTracking() {
  const {
    pathname
  } = useLocation();
  const normalizedPath = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  useElevar(elevarTrackedRoutes.includes(normalizedPath));
  return null;
}